<template>
  <div class="pos-box" v-if="$store.state.classify">
    <div v-for="file in Math.ceil(goodsList.length/3)" :key="file">
      <dl v-for="item in goodsList.slice((file-1)*3,file*3)" :key="item.id">
        <dt @click="listJump(item.id)">{{item.kind}}</dt>
        <dd @click="detailJump(ob.id)" v-for="ob in item.child" :key="ob.id" v-html="ob.name"></dd>
      </dl>
    </div>
  </div>
</template>

<script>
  import Goods from '../../assets/data/goods-list.js';

  export default {
        name: "classify",
    data(){
      return{
        show:false,
        goodsList:[]
      }
    },
    created() {
      this.goodsList = Goods.goods;
      console.log(this.goodsList)
    },
    methods:{
      listJump(path){
        this.$router.push({
          name: 'product',
          params:{
            id:path
          }
        })
      },

      detailJump(path){
        this.$router.push({
          name: 'product-detail',
          params:{
            id:path
          }
        })
      }
    },
    }
</script>

<style scoped lang="less">

  .pos-box{
    color: #333333;
    padding: 18px;
    position: absolute;
    top:35px;
    left: 0;
    width: 170px!important;
    height: auto;
    background-color: #fff;
    border: 1px solid #CCCCCC;
    transition: all 0.3s;
    z-index:998;
    div{
      height: auto;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
    dl{
      width: 125px;
      margin:0;
      dt{
        color:#002e60;
      }
      dd{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 12px;
        &:hover{
          text-decoration: underline;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/public/classify.vue